import { Paragraph } from '@zillow/constellation-10';
import styled from 'styled-components';

export const HomeLoansDashboardLinkParagraph = styled(Paragraph)`
    font-size: 14px;
`;
